import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ion-padding ion-text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "ion-padding ion-text-center"
}
const _hoisted_3 = {
  key: 2,
  class: "ion-padding event-detail"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "event-detail-title" }
const _hoisted_6 = {
  key: 0,
  class: "event-detail-meta"
}
const _hoisted_7 = { class: "event-detail-desc" }
const _hoisted_8 = {
  key: 2,
  class: "event-tiers"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: _normalizeClass(["ion-no-border events-page-header", { 'page-header--scrolled': _ctx.headerScrolled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: "",
                    "default-href": "/showcase"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Подписка", -1)
                ]))]),
                _: 1
              }),
              (_ctx.subscription && _ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_ion_buttons, {
                    key: 0,
                    slot: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/admin-subscriptions/${_ctx.subscription.id}/edit`)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_IonIcon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_content, {
        class: "main-background events-content subscription-detail-content",
        fullscreen: true,
        "scroll-y": true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Загрузка..."))
            : (!_ctx.subscription)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Подписка не найдена."))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: _ctx.subscription.logoPath ? _ctx.subscriptionsService.logoUrl(_ctx.subscription.logoPath) : _ctx.defaultLogoSrc,
                    class: _normalizeClass(["event-detail-logo", { 'event-detail-logo--default': !_ctx.subscription.logoPath }]),
                    alt: _ctx.subscription.title
                  }, null, 10, _hoisted_4),
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.subscription.title), 1),
                  (_ctx.subscription.durationDays)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Срок действия: " + _toDisplayString(_ctx.subscription.durationDays) + " " + _toDisplayString(_ctx.durationLabel(_ctx.subscription.durationDays)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.subscription.description)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "event-detail-desc-label" }, "Описание", -1)),
                        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.subscription.description), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.subscription.priceTiers?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "tiers-label" }, "Тарифы:", -1)),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscription.priceTiers, (t) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: t.id
                            }, _toDisplayString(t.name) + " — " + _toDisplayString((t.amountKopecks / 100).toFixed(0)) + " ₽", 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.myPurchase)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (_ctx.subscription.priceTiers?.length >= 2)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 0,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_select, {
                                  label: "Тариф",
                                  "cancel-text": "Отмена",
                                  modelValue: _ctx.selectedTierId,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTierId) = $event)),
                                  interface: "action-sheet",
                                  placeholder: "Выберите"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscription.priceTiers, (t) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        key: t.id,
                                        value: t.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(t.name) + " — " + _toDisplayString((t.amountKopecks / 100).toFixed(0)) + " ₽ ", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.requiresPaidPhone)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 1,
                              lines: "none",
                              class: "event-phone-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_input, {
                                  modelValue: _ctx.paymentPhone,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paymentPhone) = $event)),
                                  type: "tel",
                                  inputmode: "tel",
                                  autocomplete: "tel",
                                  name: "phone",
                                  label: "Телефон",
                                  "label-placement": "stacked",
                                  placeholder: "+7 ___ ___-__-__",
                                  onIonInput: _ctx.onPaymentPhoneInput,
                                  onIonBlur: _ctx.onPaymentPhoneBlur
                                }, null, 8, ["modelValue", "onIonInput", "onIonBlur"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.requiresPaidPhone)
                          ? (_openBlock(), _createBlock(_component_ion_note, {
                              key: 2,
                              class: "event-phone-note"
                            }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode(" Телефон обязателен для оформления подписки и нужен для связи после покупки. ", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          class: "event-register-btn",
                          disabled: _ctx.purchasing || _ctx.phoneRequiredMissing,
                          onClick: _ctx.startPurchase
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode(" Оформить подписку ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createVNode(_component_ion_note, { class: "reg-status" }, {
                          default: _withCtx(() => [
                            (_ctx.myPurchase.refundedAt)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("Возврат выполнен")
                                ], 64))
                              : (_ctx.myPurchase.active)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[10] || (_cache[10] = _createTextVNode("Подписка активна", -1)),
                                    (_ctx.myPurchase.expiresAt)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" до " + _toDisplayString(_ctx.formatDate(_ctx.myPurchase.expiresAt)), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_ctx.myPurchase.cancelledAt)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _cache[11] || (_cache[11] = _createTextVNode(" Отменена", -1)),
                                      (_ctx.myPurchase.paidAt)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(", ожидается возврат средств")
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (!_ctx.myPurchase.paidAt)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createTextVNode("Ожидает оплаты")
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _createTextVNode("Не активна")
                                      ], 64))
                          ]),
                          _: 1
                        }),
                        (!_ctx.myPurchase.paid && _ctx.subscription.priceTiers && _ctx.subscription.priceTiers.length >= 2)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 0,
                              lines: "none",
                              class: "event-tier-select-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_select, {
                                  label: "Тариф",
                                  "cancel-text": "Отмена",
                                  modelValue: _ctx.selectedTierIdForPay,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTierIdForPay) = $event)),
                                  interface: "action-sheet",
                                  placeholder: "Выберите тариф"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscription.priceTiers, (t) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        key: t.id,
                                        value: t.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(t.name) + " — " + _toDisplayString((t.amountKopecks / 100).toFixed(0)) + " ₽ ", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.showPayButton && _ctx.requiresPaidPhone)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 1,
                              lines: "none",
                              class: "event-phone-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_input, {
                                  modelValue: _ctx.paymentPhone,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paymentPhone) = $event)),
                                  type: "tel",
                                  inputmode: "tel",
                                  autocomplete: "tel",
                                  name: "phone",
                                  label: "Телефон",
                                  "label-placement": "stacked",
                                  placeholder: "+7 ___ ___-__-__",
                                  onIonInput: _ctx.onPaymentPhoneInput,
                                  onIonBlur: _ctx.onPaymentPhoneBlur
                                }, null, 8, ["modelValue", "onIonInput", "onIonBlur"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.showPayButton && _ctx.requiresPaidPhone)
                          ? (_openBlock(), _createBlock(_component_ion_note, {
                              key: 2,
                              class: "event-phone-note"
                            }, {
                              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                _createTextVNode(" Телефон обязателен для оплаты и нужен для связи после покупки. ", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.showPayButton)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 3,
                              expand: "block",
                              class: "event-pay-btn",
                              disabled: _ctx.paying || _ctx.phoneRequiredMissing,
                              onClick: _ctx.goPay
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Оплатить " + _toDisplayString((_ctx.amountToPayKopecks / 100).toFixed(0)) + " ₽ ", 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"]))
                          : _createCommentVNode("", true),
                        (!_ctx.myPurchase.paid)
                          ? (_openBlock(), _createBlock(_component_ion_note, {
                              key: 4,
                              class: "offer-note"
                            }, {
                              default: _withCtx(() => [
                                _cache[14] || (_cache[14] = _createTextVNode(" Нажимая «Оплатить», вы соглашаетесь с ", -1)),
                                _createVNode(_component_router_link, { to: "/offer-supplement" }, {
                                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createTextVNode("договором оферты", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[15] || (_cache[15] = _createTextVNode(". ", -1))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.canCancel)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 5,
                              expand: "block",
                              fill: "outline",
                              color: "warning",
                              class: "event-cancel-btn",
                              disabled: _ctx.cancelling,
                              onClick: _ctx.confirmCancel
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode(" Отменить подписку ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled", "onClick"]))
                          : _createCommentVNode("", true)
                      ], 64)),
                  _cache[17] || (_cache[17] = _createElementVNode("div", {
                    class: "event-detail-bottom-spacer",
                    "aria-hidden": "true"
                  }, null, -1))
                ]))
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}